'use client';

// import ReadMoreOrLess from '@/components/ReadMoreOrLess';
import EmblaCarousel from '@/components/EmblaCarousel';
import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';
export const CustomerFirst = () => {
  const { isMobile } = useIsMobile();
  const OPTIONS = {
    containScroll: false,
    align: 'start',
  };
  const slides = [
    {
      image: '/about-us/customer-first-1.png',
      name: 'Emi Sorensen',
      review:
        "I am loving my first pair so far! They are waterproof, insulated and lightweight. You still have enough room to put in insoles if you need to or a nice large pair of warm cozy winter socks. They also have substantial grip so you don't fall flat on your face if it's wet or muddy so I call that a win. They have styles for men and women so make sure to go check them out for your next pair.",
    },
    {
      image: '/about-us/customer-first-2.png',
      name: 'Steve',
      review:
        "I wear rubber boots 2 to 6 hours a day on our farm. Longer in times with bad weather. Comfort is important. I've been through many brands. High priced and low. The lower rubber part cracks at around 6 months on all. I've had these for 18 months and still no cracks no leaks. The camo fabric over the upper that covers the neoprene is torn but no leaks. Comfortable and durable. The size is accurate.",
    },
    {
      image: '/about-us/customer-first-3.png',
      name: 'Laura',
      review:
        'Excellent quality and value. Comfortable. Waterproof. Made of appropriate materials. Easy to slip on. Stay on during use in garden for digging, weeding and the like. I have used them daily since their arrival, in all kinds of weather: rain, snow, heat and chill.',
    },
  ];
  return (
    <div className=' bg-white  py-[40px] lg_py-[80px]'>
      <div className='container mx-auto'>
        <p className=' mb-[10px] px-[12px] font-teko-medium text-[28px] uppercase leading-[28px] text-primary lg_px-0 lg_text-[40px] lg_leading-[40px]'>
          Customer First
        </p>

        <p className='mb-[20px] mt-[10px]  px-[12px] text-left font-roboto-regular text-[16px] leading-[24px] text-primary lg_mb-[40px] lg_px-0 lg_text-[18px] lg_leading-[30px]'>
          We know that the best feedback comes from those who wear our boots every day. That's why we listen closely to
          our customers. From your reviews to your stories, you help us improve and grow. Our boots are built for you.
          Whether you're a hunter, fisherman, farmer, or explorer, Hisea is here to support your journey.
        </p>

        <div className='w-full  pl-[12px] lg_pl-0'>
          <EmblaCarousel
            slides={slides}
            options={OPTIONS}
            classes={{
              content: 'lg_grid lg_grid-cols-3 lg_gap-x-[45px]',
            }}
          >
            {(item, index) => (
              <div
                key={index}
                className=''
              >
                <div className='relative mb-[20px]'>
                  <Image
                    src={`${item.image}?v=1.2.1`}
                    alt={`customer-first-${index + 1}`}
                    width={450}
                    height={450}
                    className='h-[300px] w-[300px] lg_h-[450px] lg_w-[450px]'
                  />
                </div>
                <div className='relative w-[300px] lg_w-[450px]'>
                  <p className='mb-[5px] font-roboto-medium text-[18px] font-medium leading-[21px] text-primary lg_mb-[10px] lg_text-[22px] lg_leading-[26px] '>
                    {item.name}
                  </p>
                  <p className='font-roboto-regular text-[16px] leading-[24px] text-primary lg_text-[18px] lg_leading-[30px]'>
                    {item.review}
                  </p>
                </div>
              </div>
            )}
          </EmblaCarousel>
          {/* {slides.map((customer, index) => (
            <div
              key={index}
              className='h-fit bg-white px-[25px] py-[30px]'
            >
              <Image
                src={`${customer.image}?v=1.2.1`}
                alt={`customer-first-${index + 1}`}
                width={360}
                height={360}
                className='mb-[20px] w-full'
              />
              <p className='mt-[5px] font-roboto-medium text-[18px] font-medium leading-[21px] text-primary lg_mb-[10px] lg_text-[22px] lg_leading-[26px] '>
                {customer.name}
              </p>
              <p
                className='font-roboto-regular text-[16px] leading-[24px] text-primary lg_text-[18px] lg_leading-[30px]'
                style={{ wordWrap: 'break-word' }}
              >
                {customer.review}
              </p>
              <ReadMoreOrLess
                text={customer.review}
                isFold
                buttonClassName='text-[16px] font-urw-din-medium capitalize underline mt-2'
              />
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
};
